import * as React from 'react';
import { Message, Button, Image } from 'semantic-ui-react';
import { getI18n } from 'services/i18n-service';
import { translations } from 'types/translations';
import { LanguageCode } from 'types/tenants/language-code';
import { Notification } from 'types/notification';
import { Guid } from 'types/guid';

import './styles.css';

export interface Props {
  language: LanguageCode;
  notification: Notification;
  dismiss: (notificationId: Guid) => void;
}

const getMessage = (notification: Notification, language: LanguageCode): string => {
  if (!notification.messageByLanguage[language]) {
    return notification.messageByLanguage[LanguageCode.English];
  }

  return notification.messageByLanguage[language];
};

export const NotificationComponent: React.StatelessComponent<Props> = (props) => {
  const i18n = getI18n();

  const hyperlink = props.notification.linkUrl
    ? (
      <a className="notification-link" href={props.notification.linkUrl} target="blank">
        {i18n.t(translations.ClickHere)}
      </a>
    )
    : null;

  const dismiss = () => props.dismiss(props.notification.id);

  return (
    props.notification
      ? (
        <Message className="notification">
          <Image
            className="notification-close-button"
            onClick={dismiss}
            src="./icons/close.svg"
          />
          <Message.Content>
            <strong className="notification-message">{getMessage(props.notification, props.language)}&nbsp;{hyperlink}.</strong>
            <Button className="notification-button" onClick={dismiss}>
              {i18n.t(translations.Dismiss)}
            </Button>
          </Message.Content>
        </Message>
      )
    : null
  );
};


// WEBPACK FOOTER //
// ./src/components/notification/component.tsx